import { required, SelectArrayInput, useTranslate } from 'react-admin'
import InputAccordion from '../common/InputAccordion'
import { useBlockSource } from '../useBlockSource'

export const COMPONENT_TYPES = [
  { id: 'module', name: 'Module' },
  { id: 'inverter', name: 'Inverter' },
  { id: 'battery', name: 'Battery' },
  { id: 'other', name: 'Others' },
]

const FeaturedProductsField = (props) => {
  const translate = useTranslate()
  const source = useBlockSource('featured_products')

  // Supports backward compatibility
  const toArray= (value) => Array.isArray(value) ? value : value ? [value] : []

  return (
    <InputAccordion title={translate('Featured Products')}>
      <SelectArrayInput
        source={`${source}.component_type`}
        choices={COMPONENT_TYPES}
        translateChoice={true}
        label={'Component Type'}
        validate={required()}
        parse={(value) => toArray(value)}
        format={(value) => toArray(value)}
      />
    </InputAccordion>
  )
}

export default FeaturedProductsField
